import { ProAndCons } from '../../types/car-review-page'
import styles from './pros-and-cons.module.css'
import sharedStyles from '../../car-reviews-v2.module.css'
import { SearchButton } from '../search-button'
import { TickWithCircle } from '../assets/tick-with-circle'
import { CrossIcon } from '../assets/cross-icon'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { createProsAndConsArray } from './create-pros-and-cons-array'

interface ListItemProps {
  text: string
  isPro: boolean
}

const ListItem: React.FC<ListItemProps> = ({ text, isPro }) => (
  <li className={styles.prosAndConsListItem}>
    <span className={isPro ? styles.listItemIconPros : styles.listItemIconCons}>
      {isPro ? <TickWithCircle /> : <CrossIcon />}
    </span>
    <span className={styles.listItemText}>{text}</span>
  </li>
)

interface ProsAndConsProps {
  prosList: ProAndCons[]
  consList: ProAndCons[]
  make: string
  model: string
  areVehiclesInStock?: boolean
}

export const ProsAndCons: React.FC<ProsAndConsProps> = ({
  prosList,
  consList,
  make,
  model,
  areVehiclesInStock,
}) => {
  const { trackEvent } = useAnalytics()

  const prosAndConsData = createProsAndConsArray(prosList, consList)

  const handleClick = () => {
    trackEvent({
      eventName: `Car Review - Search for a ${make} ${model}`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.click,
          category: 'pros and cons',
          label: 'search for a vehicle',
          action: make,
          value: model,
        },
      },
    })
  }

  return (
    <section className={sharedStyles.inner}>
      <div className={styles.prosAndConsContainer}>
        {prosAndConsData.map((section, index) => (
          <div key={index} className={styles.prosAndConsSection}>
            <h2 className={styles.prosAndConsTitle}>{section.title}</h2>
            <ul>
              {section.body.map((item, itemIndex) => (
                <ListItem
                  key={itemIndex}
                  text={item}
                  isPro={section.title === 'Pros'}
                />
              ))}
            </ul>
          </div>
        ))}
      </div>
      {areVehiclesInStock && (
        <SearchButton make={make} model={model} onClick={() => handleClick()} />
      )}
    </section>
  )
}
